export default __webpack_public_path__ + "static/media/promos-3.bc9fd6c3.webp";